import React, { useState, useEffect } from 'react';
import Navigation from '../components/Navigation';

// Liste complète des parachot de la Torah
const PARACHOT = {
  'Bereshit': [
    { name: 'Bereshit', book: 'Genesis', chapters: '1:1-6:8' },
    { name: 'Noach', book: 'Genesis', chapters: '6:9-11:32' },
    { name: 'Lech-Lecha', book: 'Genesis', chapters: '12:1-17:27' },
    { name: 'Vayera', book: 'Genesis', chapters: '18:1-22:24' },
    { name: 'Chayei Sara', book: 'Genesis', chapters: '23:1-25:18' },
    { name: 'Toldot', book: 'Genesis', chapters: '25:19-28:9' },
    { name: 'Vayetzei', book: 'Genesis', chapters: '28:10-32:3' },
    { name: 'Vayishlach', book: 'Genesis', chapters: '32:4-36:43' },
    { name: 'Vayeshev', book: 'Genesis', chapters: '37:1-40:23' },
    { name: 'Miketz', book: 'Genesis', chapters: '41:1-44:17' },
    { name: 'Vayigash', book: 'Genesis', chapters: '44:18-47:27' },
    { name: 'Vayechi', book: 'Genesis', chapters: '47:28-50:26' }
  ],
  'Shemot': [
    { name: 'Shemot', book: 'Exodus', chapters: '1:1-6:1' },
    { name: 'Vaera', book: 'Exodus', chapters: '6:2-9:35' },
    { name: 'Bo', book: 'Exodus', chapters: '10:1-13:16' },
    { name: 'Beshalach', book: 'Exodus', chapters: '13:17-17:16' },
    { name: 'Yitro', book: 'Exodus', chapters: '18:1-20:23' },
    { name: 'Mishpatim', book: 'Exodus', chapters: '21:1-24:18' },
    { name: 'Terumah', book: 'Exodus', chapters: '25:1-27:19' },
    { name: 'Tetzaveh', book: 'Exodus', chapters: '27:20-30:10' },
    { name: 'Ki Tisa', book: 'Exodus', chapters: '30:11-34:35' },
    { name: 'Vayakhel', book: 'Exodus', chapters: '35:1-38:20' },
    { name: 'Pekudei', book: 'Exodus', chapters: '38:21-40:38' }
  ],
  'Vayikra': [
    { name: 'Vayikra', book: 'Leviticus', chapters: '1:1-5:26' },
    { name: 'Tzav', book: 'Leviticus', chapters: '6:1-8:36' },
    { name: 'Shmini', book: 'Leviticus', chapters: '9:1-11:47' },
    { name: 'Tazria', book: 'Leviticus', chapters: '12:1-13:59' },
    { name: 'Metzora', book: 'Leviticus', chapters: '14:1-15:33' },
    { name: 'Achrei Mot', book: 'Leviticus', chapters: '16:1-18:30' },
    { name: 'Kedoshim', book: 'Leviticus', chapters: '19:1-20:27' },
    { name: 'Emor', book: 'Leviticus', chapters: '21:1-24:23' },
    { name: 'Behar', book: 'Leviticus', chapters: '25:1-26:2' },
    { name: 'Bechukotai', book: 'Leviticus', chapters: '26:3-27:34' }
  ],
  'Bamidbar': [
    { name: 'Bamidbar', book: 'Numbers', chapters: '1:1-4:20' },
    { name: 'Nasso', book: 'Numbers', chapters: '4:21-7:89' },
    { name: 'Beha\'alotcha', book: 'Numbers', chapters: '8:1-12:16' },
    { name: 'Sh\'lach', book: 'Numbers', chapters: '13:1-15:41' },
    { name: 'Korach', book: 'Numbers', chapters: '16:1-18:32' },
    { name: 'Chukat', book: 'Numbers', chapters: '19:1-22:1' },
    { name: 'Balak', book: 'Numbers', chapters: '22:2-25:9' },
    { name: 'Pinchas', book: 'Numbers', chapters: '25:10-30:1' },
    { name: 'Matot', book: 'Numbers', chapters: '30:2-32:42' },
    { name: 'Masei', book: 'Numbers', chapters: '33:1-36:13' }
  ],
  'Devarim': [
    { name: 'Devarim', book: 'Deuteronomy', chapters: '1:1-3:22' },
    { name: 'Vaetchanan', book: 'Deuteronomy', chapters: '3:23-7:11' },
    { name: 'Eikev', book: 'Deuteronomy', chapters: '7:12-11:25' },
    { name: 'Re\'eh', book: 'Deuteronomy', chapters: '11:26-16:17' },
    { name: 'Shoftim', book: 'Deuteronomy', chapters: '16:18-21:9' },
    { name: 'Ki Teitzei', book: 'Deuteronomy', chapters: '21:10-25:19' },
    { name: 'Ki Tavo', book: 'Deuteronomy', chapters: '26:1-29:8' },
    { name: 'Nitzavim', book: 'Deuteronomy', chapters: '29:9-30:20' },
    { name: 'Vayeilech', book: 'Deuteronomy', chapters: '31:1-31:30' },
    { name: 'Ha\'Azinu', book: 'Deuteronomy', chapters: '32:1-32:52' },
    { name: 'V\'Zot HaBerachah', book: 'Deuteronomy', chapters: '33:1-34:12' }
  ]
};

const ALL_PARACHOT = Object.values(PARACHOT).flat();

// Langues disponibles
const LANGUAGES = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' }
];

function ParachaScreen() {
  const [selectedParacha, setSelectedParacha] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [textData, setTextData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filteredParachot, setFilteredParachot] = useState(ALL_PARACHOT);
  const [selectedLanguage, setSelectedLanguage] = useState('fr');
  const [availableVersions, setAvailableVersions] = useState([]);
  const [selectedVersion, setSelectedVersion] = useState(null);
  const [showHebrew, setShowHebrew] = useState(false);
  const [copySuccess, setCopySuccess] = useState(null); // 'hebrew', 'translation', ou null

  useEffect(() => {
    if (searchTerm) {
      const filtered = ALL_PARACHOT.filter(p =>
        p.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredParachot(filtered);
    } else {
      setFilteredParachot(ALL_PARACHOT);
    }
  }, [searchTerm]);

  // Récupérer les versions disponibles pour une référence
  const fetchAvailableVersions = async (ref, lang) => {
    try {
      const response = await fetch(
        `https://www.sefaria.org/api/texts/${encodeURIComponent(ref)}`
      );
      const data = await response.json();
      
      const versions = [];
      if (data.versions) {
        data.versions.forEach(version => {
          versions.push({
            language: version.language,
            versionTitle: version.versionTitle,
            versionSource: version.versionSource
          });
        });
      }
      
      return versions;
    } catch (err) {
      console.error('Erreur lors de la récupération des versions:', err);
      return [];
    }
  };

  // Récupérer le texte avec traduction
  const fetchParachaText = async (paracha, language = selectedLanguage, version = null) => {
    setLoading(true);
    setError(null);
    setTextData(null);
    // Réinitialiser la visibilité de l'hébreu à false quand on charge un nouveau texte
    setShowHebrew(false);

    try {
      const ref = `${paracha.book}.${paracha.chapters}`;
      
      const versions = await fetchAvailableVersions(ref, language);
      setAvailableVersions(versions);

      const langVersions = versions.filter(v => 
        v.language.toLowerCase() === language.toLowerCase()
      );

      let url = `https://www.sefaria.org/api/texts/${encodeURIComponent(ref)}`;
      
      if (version) {
        url = `https://www.sefaria.org/api/texts/${encodeURIComponent(ref)}/${language}/${encodeURIComponent(version)}`;
      } else if (langVersions.length > 0) {
        url = `https://www.sefaria.org/api/texts/${encodeURIComponent(ref)}/${language}/${encodeURIComponent(langVersions[0].versionTitle)}`;
        setSelectedVersion(langVersions[0].versionTitle);
      }

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Erreur ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      
      if ((!data.text || data.text.length === 0) && language !== 'en') {
        console.log('Aucune traduction trouvée, tentative en anglais...');
        return fetchParachaText(paracha, 'en', null);
      }

      setTextData(data);
    } catch (err) {
      setError(err.message);
      console.error('Erreur lors de la récupération du texte:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleParachaSelect = (e) => {
    const parachaName = e.target.value;
    setSelectedParacha(parachaName);
    setSearchTerm('');

    const paracha = ALL_PARACHOT.find(p => p.name === parachaName);
    if (paracha) {
      fetchParachaText(paracha, selectedLanguage);
    }
  };

  const handleSearchSelect = (paracha) => {
    setSelectedParacha(paracha.name);
    setSearchTerm('');
    fetchParachaText(paracha, selectedLanguage);
  };

  const handleLanguageChange = (e) => {
    const newLang = e.target.value;
    setSelectedLanguage(newLang);
    
    if (selectedParacha) {
      const paracha = ALL_PARACHOT.find(p => p.name === selectedParacha);
      if (paracha) {
        fetchParachaText(paracha, newLang);
      }
    }
  };

  const handleVersionChange = (e) => {
    const version = e.target.value;
    setSelectedVersion(version);
    
    if (selectedParacha) {
      const paracha = ALL_PARACHOT.find(p => p.name === selectedParacha);
      if (paracha) {
        fetchParachaText(paracha, selectedLanguage, version);
      }
    }
  };

  // Fonction pour extraire le texte brut (sans HTML) d'un élément
  const extractPlainText = (text) => {
    if (typeof text === 'string') {
      // Supprimer les balises HTML
      const tempDiv = typeof document !== 'undefined' ? document.createElement('div') : null;
      if (tempDiv) {
        tempDiv.innerHTML = text;
        return tempDiv.textContent || tempDiv.innerText || '';
      }
      // Fallback: supprimer les balises HTML avec regex
      return text.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
    }
    if (Array.isArray(text)) {
      return text.map(extractPlainText).join(' ');
    }
    return String(text || '');
  };

  // Fonction pour copier le texte dans le presse-papiers
  const handleCopyText = async (section = 'all') => {
    if (!textData) return;

    let textToCopy = '';

    // Ajouter le titre seulement si on copie tout
    if (section === 'all') {
      if (textData.ref || selectedParacha) {
        textToCopy += `${textData.ref || selectedParacha}\n\n`;
      }
      if (textData.versionTitle) {
        textToCopy += `Version: ${textData.versionTitle}\n\n`;
      }
    }

    // Copier seulement l'hébreu
    if (section === 'hebrew' || section === 'all') {
      if (textData.he && textData.he.length > 0) {
        if (section === 'all' && textToCopy) textToCopy += '\n';
        textToCopy += 'עברית (Hébreu)\n';
        textToCopy += '='.repeat(50) + '\n';
        if (Array.isArray(textData.he)) {
          textData.he.forEach((verse, index) => {
            if (Array.isArray(verse)) {
              verse.forEach((subVerse, subIndex) => {
                textToCopy += `${index + 1}:${subIndex + 1} ${extractPlainText(subVerse)}\n`;
              });
            } else {
              textToCopy += `${index + 1} ${extractPlainText(verse)}\n`;
            }
          });
        } else {
          textToCopy += extractPlainText(textData.he) + '\n';
        }
        if (section === 'all') textToCopy += '\n';
      }
    }

    // Copier seulement la traduction
    if (section === 'translation' || section === 'all') {
      if (textData.text && textData.text.length > 0) {
        if (section === 'all' && textToCopy) textToCopy += '\n';
        const langName = LANGUAGES.find(l => l.code === selectedLanguage)?.name || selectedLanguage;
        textToCopy += `Traduction (${langName})\n`;
        textToCopy += '='.repeat(50) + '\n';
        if (Array.isArray(textData.text)) {
          textData.text.forEach((verse, index) => {
            if (Array.isArray(verse)) {
              verse.forEach((subVerse, subIndex) => {
                textToCopy += `${index + 1}:${subIndex + 1} ${extractPlainText(subVerse)}\n`;
              });
            } else {
              textToCopy += `${index + 1} ${extractPlainText(verse)}\n`;
            }
          });
        } else {
          textToCopy += extractPlainText(textData.text) + '\n';
        }
      }
    }

    // Copier dans le presse-papiers
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopySuccess(section);
      setTimeout(() => setCopySuccess(null), 2000);
    } catch (err) {
      console.error('Erreur lors de la copie:', err);
      // Fallback pour les anciens navigateurs
      const textArea = document.createElement('textarea');
      textArea.value = textToCopy;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        setCopySuccess(section);
        setTimeout(() => setCopySuccess(null), 2000);
      } catch (fallbackErr) {
        console.error('Erreur avec le fallback:', fallbackErr);
      }
      document.body.removeChild(textArea);
    }
  };

  // Fonction pour parser le HTML et le convertir en éléments React
  const parseHTML = (htmlString) => {
    if (typeof htmlString !== 'string') return htmlString;
    if (typeof document === 'undefined') return htmlString; // Fallback si pas dans le navigateur
    
    // Créer un élément temporaire pour parser le HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    
    // Fonction récursive pour convertir les nœuds DOM en éléments React
    const convertNode = (node, key = 0) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent;
        return text ? text : null;
      }
      
      if (node.nodeType === Node.ELEMENT_NODE) {
        const tagName = node.tagName.toLowerCase();
        const props = { key: `html-${key}` };
        
        // Gérer les classes CSS
        if (node.className && typeof node.className === 'string') {
          props.className = node.className;
        }
        
        // Gérer les styles pour certaines balises
        if (tagName === 'sup') {
          props.style = { 
            fontSize: '0.8em', 
            verticalAlign: 'super',
            color: '#4A90E2',
            cursor: 'help',
            fontWeight: 'bold'
          };
        }
        
        if (tagName === 'i' && node.className && node.className.includes('footnote')) {
          props.style = {
            fontSize: '0.9em',
            fontStyle: 'italic',
            color: '#7F8C8D',
            display: 'block',
            marginTop: '5px',
            marginBottom: '5px',
            paddingLeft: '10px',
            borderLeft: '2px solid #ECF0F1'
          };
        }
        
        if (tagName === 'b') {
          props.style = { fontWeight: 'bold' };
        }
        
        // Convertir les enfants
        const children = [];
        Array.from(node.childNodes).forEach((child, idx) => {
          const converted = convertNode(child, `${key}-${idx}`);
          if (converted !== null && converted !== undefined) {
            if (Array.isArray(converted)) {
              children.push(...converted);
            } else {
              children.push(converted);
            }
          }
        });
        
        // Si pas d'enfants, retourner null pour éviter les éléments vides
        if (children.length === 0) {
          return null;
        }
        
        return React.createElement(tagName, props, ...children);
      }
      
      return null;
    };
    
    // Convertir tous les nœuds et aplatir le résultat
    const result = [];
    Array.from(tempDiv.childNodes).forEach((node, idx) => {
      const converted = convertNode(node, idx);
      if (converted !== null && converted !== undefined) {
        if (Array.isArray(converted)) {
          result.push(...converted);
        } else {
          result.push(converted);
        }
      }
    });
    
    // Si un seul élément, le retourner directement, sinon retourner un tableau
    return result.length === 1 ? result[0] : result;
  };

  const renderText = (text, isHebrew = false) => {
    if (!text) return null;

    // Fonction helper pour normaliser le contenu (peut être du HTML ou non)
    const normalizeContent = (content) => {
      if (typeof content === 'string' && content.includes('<')) {
        const parsed = parseHTML(content);
        return Array.isArray(parsed) ? parsed : [parsed];
      }
      return [content];
    };

    if (Array.isArray(text)) {
      return text.map((verse, index) => {
        if (Array.isArray(verse)) {
          return verse.map((subVerse, subIndex) => {
            const verseContent = normalizeContent(subVerse);
            
            return React.createElement('p', {
              key: `verse-${index}-${subIndex}`,
              style: styles.verse
            }, [
              React.createElement('span', {
                key: 'number',
                style: styles.verseNumber
              }, `${index + 1}:${subIndex + 1}`),
              ' ',
              ...verseContent
            ]);
          });
        }
        
        const verseContent = normalizeContent(verse);
        
        return React.createElement('p', {
          key: `verse-${index}`,
          style: styles.verse
        }, [
          React.createElement('span', {
            key: 'number',
            style: styles.verseNumber
          }, `${index + 1}`),
          ' ',
          ...verseContent
        ]);
      });
    }

    // Si c'est une chaîne avec du HTML
    if (typeof text === 'string') {
      const parsedContent = normalizeContent(text);
      return React.createElement('p', { 
        style: styles.verse 
      }, ...parsedContent);
    }

    return React.createElement('p', { style: styles.verse }, text);
  };

  const filteredVersions = availableVersions.filter(v => 
    v.language.toLowerCase() === selectedLanguage.toLowerCase()
  );

  return React.createElement(React.Fragment, {}, [
    React.createElement(Navigation, { key: 'navigation' }),
    React.createElement('div', { key: 'main-container', style: styles.container }, [
      // Header
      React.createElement('div', { key: 'header', style: styles.header }, [
        React.createElement('h1', { key: 'title', style: styles.title }, '📖 Recherche de Parachot'),
        React.createElement('p', { key: 'subtitle', style: styles.subtitle }, 'Sélectionnez ou recherchez une paracha de la Torah')
      ]),

    // Search Section
    React.createElement('div', { key: 'search-section', style: styles.searchSection }, [
      // Sélecteur de langue
      React.createElement('div', { key: 'lang-group', style: styles.inputGroup }, [
        React.createElement('label', { key: 'lang-label', style: styles.label }, '🌍 Langue de traduction :'),
        React.createElement('select', {
          key: 'lang-select',
          value: selectedLanguage,
          onChange: handleLanguageChange,
          style: styles.select
        }, LANGUAGES.map(lang =>
          React.createElement('option', {
            key: lang.code,
            value: lang.code
          }, `${lang.flag} ${lang.name}`)
        ))
      ]),

      // Dropdown de sélection
      React.createElement('div', { key: 'paracha-group', style: styles.inputGroup }, [
        React.createElement('label', { key: 'paracha-label', style: styles.label }, 'Choisir une paracha :'),
        React.createElement('select', {
          key: 'paracha-select',
          value: selectedParacha,
          onChange: handleParachaSelect,
          style: styles.select
        }, [
          React.createElement('option', { key: 'default', value: '' }, '-- Sélectionnez une paracha --'),
          ...Object.entries(PARACHOT).map(([book, parachot]) =>
            React.createElement('optgroup', { key: book, label: book },
              parachot.map(paracha =>
                React.createElement('option', {
                  key: paracha.name,
                  value: paracha.name
                }, `${paracha.name} (${paracha.chapters})`)
              )
            )
          )
        ])
      ]),

      // Divider
      React.createElement('div', { key: 'divider', style: styles.divider },
        React.createElement('span', { style: styles.dividerText }, 'OU')
      ),

      // Champ de recherche
      React.createElement('div', { key: 'search-group', style: styles.inputGroup }, [
        React.createElement('label', { key: 'search-label', style: styles.label }, 'Rechercher :'),
        React.createElement('input', {
          key: 'search-input',
          type: 'text',
          value: searchTerm,
          onChange: (e) => setSearchTerm(e.target.value),
          placeholder: 'Ex: Bereshit, Noach, Lech-Lecha...',
          style: styles.input
        }),
        searchTerm && filteredParachot.length > 0 && React.createElement('div', {
          key: 'suggestions',
          style: styles.suggestions
        }, filteredParachot.map(paracha =>
          React.createElement('div', {
            key: paracha.name,
            onClick: () => handleSearchSelect(paracha),
            style: styles.suggestionItem
          }, [
            React.createElement('strong', { key: 'name' }, paracha.name),
            React.createElement('span', {
              key: 'details',
              style: styles.suggestionDetails
            }, ` - ${paracha.book} ${paracha.chapters}`)
          ])
        ))
      ]),

      // Sélecteur de version
      filteredVersions.length > 1 && React.createElement('div', { key: 'version-group', style: styles.inputGroup }, [
        React.createElement('label', { key: 'version-label', style: styles.label }, '📚 Version de traduction :'),
        React.createElement('select', {
          key: 'version-select',
          value: selectedVersion || '',
          onChange: handleVersionChange,
          style: styles.select
        }, filteredVersions.map(version =>
          React.createElement('option', {
            key: version.versionTitle,
            value: version.versionTitle
          }, version.versionTitle)
        ))
      ])
    ]),

    // Loading
    loading && React.createElement('div', { key: 'loading', style: styles.loading }, [
      React.createElement('div', { key: 'spinner', style: styles.spinner }),
      React.createElement('p', { key: 'text' }, 'Chargement du texte...')
    ]),

    // Erreur
    error && React.createElement('div', { key: 'error', style: styles.error }, [
      React.createElement('strong', { key: 'title' }, '❌ Erreur : '),
      error
    ]),

    // Affichage du texte
    textData && !loading && React.createElement('div', { key: 'text-container', style: styles.textContainer }, [
      // Header du texte
      React.createElement('div', { key: 'text-header', style: styles.textHeader }, [
        React.createElement('h2', { key: 'text-title', style: styles.textTitle }, textData.ref || selectedParacha),
        textData.versionTitle && React.createElement('p', { key: 'version', style: styles.version }, [
          'Version: ',
          textData.versionTitle,
          textData.versionSource && React.createElement('span', { key: 'source' }, [
            ' - ',
            React.createElement('a', {
              href: textData.versionSource,
              target: '_blank',
              rel: 'noopener noreferrer',
              style: styles.sourceLink
            }, 'Source')
          ])
        ])
      ]),

      // Bouton pour afficher/masquer l'hébreu (seulement si une traduction existe)
      textData.text && textData.text.length > 0 && textData.he && textData.he.length > 0 && React.createElement('div', { key: 'hebrew-toggle', style: styles.toggleContainer }, 
        React.createElement('button', {
          onClick: () => setShowHebrew(!showHebrew),
          style: styles.toggleButton
        }, [
          showHebrew ? '🔽' : '▶️',
          ' ',
          showHebrew ? 'Masquer' : 'Afficher',
          ' le texte hébreu'
        ])
      ),

      // Texte hébreu (affiché seulement si showHebrew est true OU si pas de traduction)
      textData.he && textData.he.length > 0 && (showHebrew || !textData.text || textData.text.length === 0) && React.createElement('div', { key: 'hebrew', style: styles.hebrewSection }, [
        React.createElement('div', { key: 'hebrew-header', style: styles.sectionHeader }, [
          React.createElement('h3', { key: 'title', style: styles.sectionTitle }, 'עברית (Hébreu)'),
          React.createElement('button', {
            key: 'copy-button-hebrew',
            onClick: () => handleCopyText('hebrew'),
            style: {
              ...styles.copyButtonSmall,
              ...(copySuccess === 'hebrew' ? styles.copyButtonSuccess : {})
            },
            title: 'Copier le texte hébreu'
          }, copySuccess === 'hebrew' ? '✓' : '📋')
        ]),
        React.createElement('div', {
          key: 'content',
          style: { ...styles.textContent, direction: 'rtl' }
        }, renderText(textData.he, true))
      ]),

      // Traduction
      textData.text && textData.text.length > 0 ? React.createElement('div', { key: 'translation', style: styles.translationSection }, [
        React.createElement('div', { key: 'translation-header', style: styles.sectionHeader }, [
          React.createElement('h3', { key: 'title', style: styles.sectionTitle }, 
            `Traduction (${LANGUAGES.find(l => l.code === selectedLanguage)?.name})`
          ),
          React.createElement('button', {
            key: 'copy-button-translation',
            onClick: () => handleCopyText('translation'),
            style: {
              ...styles.copyButtonSmall,
              ...(copySuccess === 'translation' ? styles.copyButtonSuccess : {})
            },
            title: 'Copier la traduction'
          }, copySuccess === 'translation' ? '✓' : '📋')
        ]),
        React.createElement('div', { key: 'content', style: styles.textContent }, renderText(textData.text))
      ]) : React.createElement('div', { key: 'warning', style: styles.warningBox }, [
        React.createElement('p', { key: 'warn1' }, 
          `⚠️ Aucune traduction disponible en ${LANGUAGES.find(l => l.code === selectedLanguage)?.name} pour ce texte.`
        ),
        React.createElement('p', { key: 'warn2' }, 
          'Essayez de changer la langue ou consultez le texte hébreu ci-dessus.'
        )
      ]),

      // Lien vers Sefaria
      textData.ref && React.createElement('div', { key: 'footer', style: styles.footer },
        React.createElement('a', {
          href: `https://www.sefaria.org/${textData.ref.replace(/ /g, '_')}`,
          target: '_blank',
          rel: 'noopener noreferrer',
          style: styles.link
        }, '📚 Voir sur Sefaria.org →')
      )
    ]),

      // Message d'invite
      !textData && !loading && !error && React.createElement('div', { key: 'empty', style: styles.emptyState },
        React.createElement('p', { style: styles.emptyText }, 
          '👆 Sélectionnez ou recherchez une paracha pour afficher son texte'
        )
      )
    ])
  ]);
}

// Styles
const styles = {
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '20px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px',
    borderBottom: '3px solid #4A90E2',
    paddingBottom: '20px',
  },
  title: {
    fontSize: '36px',
    color: '#2C3E50',
    margin: '0 0 10px 0',
  },
  subtitle: {
    fontSize: '16px',
    color: '#7F8C8D',
    margin: 0,
  },
  searchSection: {
    backgroundColor: '#F8F9FA',
    padding: '30px',
    borderRadius: '12px',
    marginBottom: '30px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  inputGroup: {
    marginBottom: '20px',
    position: 'relative',
  },
  langRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px',
  },
  copyButton: {
    padding: '8px 16px',
    backgroundColor: '#4A90E2',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    whiteSpace: 'nowrap',
  },
  copyButtonSuccess: {
    backgroundColor: '#27AE60',
  },
  copyButtonDisabled: {
    backgroundColor: '#BDC3C7',
    cursor: 'not-allowed',
    opacity: 0.6,
  },
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: '600',
    color: '#34495E',
    marginBottom: '8px',
  },
  select: {
    width: '100%',
    padding: '12px',
    fontSize: '16px',
    border: '2px solid #DFE6E9',
    borderRadius: '8px',
    backgroundColor: 'white',
    cursor: 'pointer',
    transition: 'border-color 0.3s',
  },
  input: {
    width: '100%',
    padding: '12px',
    fontSize: '16px',
    border: '2px solid #DFE6E9',
    borderRadius: '8px',
    boxSizing: 'border-box',
    transition: 'border-color 0.3s',
  },
  divider: {
    textAlign: 'center',
    margin: '30px 0',
    position: 'relative',
  },
  dividerText: {
    backgroundColor: '#F8F9FA',
    padding: '0 15px',
    color: '#95A5A6',
    fontWeight: '600',
    fontSize: '14px',
  },
  suggestions: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: 'white',
    border: '2px solid #DFE6E9',
    borderTop: 'none',
    borderRadius: '0 0 8px 8px',
    maxHeight: '300px',
    overflowY: 'auto',
    zIndex: 1000,
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  },
  suggestionItem: {
    padding: '12px 16px',
    cursor: 'pointer',
    borderBottom: '1px solid #F0F0F0',
    transition: 'background-color 0.2s',
  },
  suggestionDetails: {
    color: '#7F8C8D',
    fontSize: '14px',
  },
  loading: {
    textAlign: 'center',
    padding: '60px 20px',
    color: '#7F8C8D',
  },
  spinner: {
    width: '50px',
    height: '50px',
    border: '4px solid #F0F0F0',
    borderTop: '4px solid #4A90E2',
    borderRadius: '50%',
    margin: '0 auto 20px',
    animation: 'spin 1s linear infinite',
  },
  error: {
    backgroundColor: '#FFE5E5',
    color: '#C0392B',
    padding: '20px',
    borderRadius: '8px',
    marginBottom: '20px',
    border: '2px solid #E74C3C',
  },
  warningBox: {
    backgroundColor: '#FFF3CD',
    color: '#856404',
    padding: '20px',
    borderRadius: '8px',
    marginBottom: '20px',
    border: '2px solid #FFC107',
  },
  textContainer: {
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '30px',
    boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
  },
  textHeader: {
    borderBottom: '2px solid #ECF0F1',
    paddingBottom: '20px',
    marginBottom: '30px',
  },
  textTitle: {
    fontSize: '28px',
    color: '#2C3E50',
    margin: '0 0 10px 0',
  },
  version: {
    color: '#7F8C8D',
    fontSize: '14px',
    margin: 0,
  },
  sourceLink: {
    color: '#4A90E2',
    textDecoration: 'none',
  },
  toggleContainer: {
    marginBottom: '20px',
    textAlign: 'center',
  },
  toggleButton: {
    padding: '10px 20px',
    backgroundColor: '#4A90E2',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  hebrewSection: {
    marginBottom: '40px',
  },
  translationSection: {
    marginBottom: '20px',
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    paddingBottom: '10px',
    borderBottom: '2px solid #ECF0F1',
  },
  sectionTitle: {
    fontSize: '20px',
    color: '#34495E',
    margin: 0,
  },
  copyButtonSmall: {
    padding: '6px 12px',
    backgroundColor: '#4A90E2',
    color: 'white',
    border: 'none',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    whiteSpace: 'nowrap',
  },
  textContent: {
    fontSize: '18px',
    lineHeight: '1.8',
    color: '#2C3E50',
  },
  verse: {
    marginBottom: '15px',
    padding: '10px',
    backgroundColor: '#F8F9FA',
    borderRadius: '6px',
    borderLeft: '4px solid #4A90E2',
  },
  verseNumber: {
    fontWeight: 'bold',
    color: '#4A90E2',
    marginRight: '8px',
    fontSize: '14px',
  },
  footer: {
    marginTop: '30px',
    paddingTop: '20px',
    borderTop: '2px solid #ECF0F1',
    textAlign: 'center',
  },
  link: {
    display: 'inline-block',
    padding: '12px 24px',
    backgroundColor: '#4A90E2',
    color: 'white',
    textDecoration: 'none',
    borderRadius: '8px',
    fontWeight: '600',
    transition: 'background-color 0.3s',
  },
  emptyState: {
    textAlign: 'center',
    padding: '80px 20px',
    color: '#95A5A6',
  },
  emptyText: {
    fontSize: '18px',
  },
};

// CSS pour les animations
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.textContent = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    
    input:focus, select:focus {
      outline: none;
      border-color: #4A90E2 !important;
    }
    
    button:hover {
      background-color: #357ABD !important;
    }
  `;
  if (!document.head.querySelector('style[data-paracha-spinner]')) {
    styleSheet.setAttribute('data-paracha-spinner', 'true');
    document.head.appendChild(styleSheet);
  }
}

export default ParachaScreen;